/**
 * KOA-13392 — Kuika data type -> `/images/action-icons` file name, for the type glyphs the
 * SQL Action editor shows next to a value's type.
 *
 * Shared so the editor's two halves cannot drift: the Parameters panel and the schema tree
 * read the same table. A type with no entry renders without an icon rather than a fallback
 * glyph — a wrong icon reads as a wrong type.
 */
const DATA_TYPE_ICONS: Record<string, string> = {
  Boolean: "boolean",
  Byte: "file-content",
  Bytea: "file-content",
  DateTimeOffset: "datetimeoffset",
  Decimal: "decimal",
  Double: "double",
  Date: "calendar-month",
  DateTime: "date&time",
  FileContent: "file-content",
  Guid: "GUID",
  Int16: "int16",
  Int32: "int32",
  Int64: "int64",
  Location: "location",
  Signature: "signature",
  Single: "double",
  String: "string",
  Time: "date&time"
};

/**
 * Case-insensitive on purpose: parameter types arrive PascalCase (`Int32`) while column
 * metadata has been seen lower-cased on some datasource paths.
 */
export function getDataTypeIconName(typeName: string | null | undefined): string | undefined {
  if (!typeName) return undefined;

  const direct: string | undefined = DATA_TYPE_ICONS[typeName];
  if (direct) return direct;

  const match: string | undefined = Object.keys(DATA_TYPE_ICONS).find(
    (key: string): boolean => key.toLowerCase() === typeName.toLowerCase()
  );
  return match ? DATA_TYPE_ICONS[match] : undefined;
}
